import { useTranslation } from 'react-i18next';

import { HelpTip } from './HelpTip';

interface LegendItem {
  color: string;
  label: string;
  helpKey: string;
  dashed?: boolean;
}

interface Props {
  /** `forecastPage.chartLegend` or `consensus.chartLegend` */
  i18nPrefix: string;
}

export function ChartLegendHelp({ i18nPrefix }: Props) {
  const { t } = useTranslation();

  const items: LegendItem[] = [
    { color: '#64748b', label: t(`${i18nPrefix}.actual`), helpKey: `${i18nPrefix}.actualHelp` },
    { color: '#0ea5e9', label: t(`${i18nPrefix}.forecast`), helpKey: `${i18nPrefix}.forecastHelp` },
    {
      color: '#7dd3fc',
      label: t(`${i18nPrefix}.bounds`),
      helpKey: `${i18nPrefix}.boundsHelp`,
      dashed: true,
    },
    {
      color: '#94a3b8',
      label: t(`${i18nPrefix}.currentPeriod`),
      helpKey: `${i18nPrefix}.currentPeriodHelp`,
      dashed: true,
    },
  ];

  return (
    <div className="mt-4 flex flex-wrap gap-x-4 gap-y-2 rounded-lg border border-gray-100 bg-gray-50 px-3 py-2">
      {items.map((item) => (
        <div key={item.helpKey} className="flex items-center gap-1.5 text-xs text-gray-700">
          <span
            className="inline-block h-0.5 w-5 shrink-0"
            style={{
              backgroundColor: item.dashed ? 'transparent' : item.color,
              borderTop: item.dashed ? `2px dashed ${item.color}` : undefined,
            }}
          />
          <span>{item.label}</span>
          <HelpTip>{t(item.helpKey)}</HelpTip>
        </div>
      ))}
    </div>
  );
}
